import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  INotification,
  INotificationResponseData,
  INotificationState,
} from "../types/notification";
import { IApiResponse } from "../types/api-response";

const initialState: INotificationState = {
  notifications: [],
  notification: null,
  limit: 20,
  offset: 0,
  total: 0,
  loading: false,
  error: null,
  deletingIds: null,
};

export const notification = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotifications: (
      state,
      action: PayloadAction<IApiResponse<INotificationResponseData>>,
    ) => {
      state.notifications = action.payload.data.data;
      state.limit = action.payload.data.limit;
      state.offset = action.payload.data.offset;
      state.total = action.payload.data.total;
    },
    setNotification: (state, action: PayloadAction<INotification>) => {
      state.notification = action.payload;
    },
    createNotification: (state, action: PayloadAction<INotification>) => {
      state.notifications = [action.payload, ...state.notifications];
      state.total += 1;
    },
    deleteNotification: (state, action: PayloadAction<number>) => {
      state.notifications = state.notifications.filter(
        (item) => item.id !== action.payload,
      );
      state.total = Math.max(0, state.total - 1);
      if (state.deletingIds === action.payload) {
        state.deletingIds = null;
      }

      if (state.notification?.id === action.payload) {
        state.notification = null;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },

    setLoadingId: (state, action: PayloadAction<number | null>) => {
      state.deletingIds = action.payload;
    },

    clearNotifications: (state) => {
      state.notifications = [];
      state.notification = null;
      state.total = 0;
      state.limit = 20;
      state.offset = 0;
      state.deletingIds = null;
    },
  },
});

export const {
  setNotifications,
  setNotification,
  createNotification,
  deleteNotification,
  setLoading,
  setLoadingId,
  clearNotifications,
} = notification.actions;

export default notification.reducer;
